import { Utilisateur } from '@estel-numerique/galaclick-api';
import { TraductionCoreService } from '@estel-numerique/galaclick-core';
import { PlanJourEve } from './plan-jour-eve.model';
import { isWeekend } from 'date-fns';

export class PlanJour {
    nomJour: string;

    constructor(
        date: Date,
        traductionsService: TraductionCoreService) {

        this.date = date;
        this.nomJour = traductionsService.getNomJours()[date.getDay()];
    }

    public date: Date;
    public isFerie = false;

    public agentsEve: Map<string, PlanJourEve[]> = new Map<string, PlanJourEve[]>();

    get isWeekEnd(): boolean {
        return isWeekend(this.date);
    }

    public getPlanJourAgent(agent: Utilisateur): PlanJourEve[] {
        return this.agentsEve.get(String(agent.USRID)) || [];
    }
}
